
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg","fill-rule":"evenodd","clip-rule":"evenodd","stroke-linecap":"round","stroke-linejoin":"round"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M21.324 8.148v11.798c0 1.579-1.3 2.878-2.878 2.878H4.054c-1.579 0-2.878-1.3-2.878-2.878V5.554c0-1.579 1.3-2.878 2.878-2.878h13.322","fill":"#fff","fill-rule":"nonzero","stroke":"#000","stroke-width":"1.91886"}}),_c('path',{attrs:{"d":"M6.75 9l3.294 4.611a1.526 1.526 0 002.414.09l9.324-11.19","fill":"none","stroke":"#000","stroke-width":"4"}})])
          )
        }
      }
    